import { Observable } from "rxjs";

export abstract class WhatsappRepo {
  /**
   * Shares a message and returs the app where the message is shared.
   * @param message
   */
  abstract sendMessage(
    message: string,
    phoneNumber: string
  ): Observable<string>;
}
